import moment from "moment";

export const DateFormats = {
  WithTimeZone: "YYYY-MM-DDTHH:mm:ssZ",
  SimpleDate: "YYYY/MM/DD",
  MiladiDate: "YYYY-MM-DD",
  MiladiDateTime: "YYYY-MM-DDTHH:mm:ss",
  HourAndMinute: "HH:mm",
  DateTime: "YYYY-MM-DD HH:mm",
  LongDate: "ddd DD MMMM YYYY",
  MonthYear: "MMMM YYYY",
  DateTimeZone: "YYYY-MM-DD HH:mm:ss.SSS Z",
  WithAmPm: "h:mm A",
  DayMonthDate: "DD MMM",
  MonthYearDate: "MMMM YYYY",
  LongDayWithTime: "ddd D MMMM YYYY, HH:mm",
  MonthDetailDate: "dddd DD MMMM",

  JWithTimeZone: "jYYYY-jMM-jDDTHH:mm:ss.SSS Z",
  JSimpleDate: "jYYYY/jMM/jDD",
  JDateTime: "jYYYY-jMM-jDD HH:mm",
  JLongDate: "ddd jDD jMMMM jYYYY",
  JDayMonthDate: "jDD jMMMM",
  JMonthDetailDate: "dddd jDD jMMMM",
  JMonthYearDate: "jMMMM jYYYY",
  JLongDayWithTime: "dddd jD jMMMM jYYYY، HH:mm",
  JDateTimeZone: "jYYYY-jMM-jDD HH:mm:ss.SSS Z",
};

const DateWithTimeZone = (date) => {
  return moment(date, DateFormats.WithTimeZone);
};

export const getUserTimeZone = () => {
  // Check if the Intl.DateTimeFormat and options.timeZone are supported
  if (typeof Intl === "object" && typeof Intl.DateTimeFormat === "function") {
    // Get the current date and time in the user's locale
    const now = new Date();

    // Create an Intl.DateTimeFormat object for the user's locale
    const formatter = new Intl.DateTimeFormat([], {
      timeZoneName: "longGeneric",
    });

    // Format the current date to get the time zone information
    const timeZoneInfo = formatter
      .formatToParts(now)
      .find((part) => part.type === "timeZoneName");

    // Extract and return the time zone from the formatted string
    return "local"; // Return 'UTC' if unable to detect the time zone
    //   return timeZoneInfo ? timeZoneInfo.value : "UTC"; // Return 'UTC' if unable to detect the time zone
  }

  // Return 'UTC' as a fallback if Intl.DateTimeFormat is not supported
  return "UTC";
};

const DateFormatter = {
  DateWithTimeZone,
  getUserTimeZone,
};

export default DateFormatter;
